import React, { Fragment } from 'react';
import map from 'lodash/map';

import { VisuallyHiddenP } from 'zoomforth_codesbane_viewer/component_lib/visually_hidden.jsx';

import SiteViewerVersionComponentSelector
  from 'zoomforth_codesbane_viewer/component_lib/site_viewer_version_component_selector_container.jsx';

import LanguageSelector from 'zoomforth_component_lib/translations_language_selector_container.jsx';


const ManNavInner_ViewerVersion1 = ({
  MenuItemComponent,
  SubmenuItemComponent,
  menuItem,
  currentSubpage,
  currentSubmenuItems,
  lastClickedSubmenuItemId,
})=> (
  <Fragment>
    <div className="nav-link-super-wrapper">
      <MenuItemComponent
        menuItem={menuItem}
        currentSubpage={currentSubpage}
        selected={
          lastClickedSubmenuItemId ?
            false
          :
            menuItem.appAction.subpageId === currentSubpage.id && menuItem.isPrimaryForSubpage
        }
      />
    </div>

    {
      map(currentSubmenuItems, submenuItem => (
        <div key={submenuItem.id} className="nav-link-super-wrapper">
          <SubmenuItemComponent
            submenuItem={submenuItem}
            currentSubpage={currentSubpage}
            lastClickedSubmenuItemId={lastClickedSubmenuItemId}
          />
        </div>
      ))
    }
  </Fragment>
);


const MainNavigationWithToplevelSubmenuLinksUi_ViewerVersion1 = ({
  MenuItemComponent,
  SubmenuItemComponent,
  menuItem,
  currentSubpage,
  currentSubmenuItems,
  lastClickedSubmenuItemId,
  isTranslationsEnabled,
  appliedLanguages,
  currentLanguageIso,
  defaultLanguageIso,
  onLanguageChange
})=> (
  <div key="main-navigation" className="navigation-links-container">
    {
      isTranslationsEnabled ?
        <Fragment>
          <div className="navigation-links-left">
            <ManNavInner_ViewerVersion1 
              menuItem={menuItem}
              currentSubpage={currentSubpage}
              lastClickedSubmenuItemId={lastClickedSubmenuItemId}
              currentSubmenuItems={currentSubmenuItems}
              MenuItemComponent={MenuItemComponent}
              SubmenuItemComponent={SubmenuItemComponent}
            />
          </div>

          <LanguageSelector
            currentIso={currentLanguageIso}
            defaultLanguageIso={defaultLanguageIso}
            appliedLanguages={appliedLanguages}
            onLanguageChange={onLanguageChange}
          />
        </Fragment>
      :
        <ManNavInner_ViewerVersion1 
          menuItem={menuItem}
          currentSubpage={currentSubpage}
          lastClickedSubmenuItemId={lastClickedSubmenuItemId}
          currentSubmenuItems={currentSubmenuItems}
          MenuItemComponent={MenuItemComponent}
          SubmenuItemComponent={SubmenuItemComponent}
        />
    }
  </div>
);

const ManNavInner_ViewerVersion2 = ({
  MenuItemComponent,
  SubmenuItemComponent,
  menuItem,
  currentSubpage,
  currentSubmenuItems,
  lastClickedSubmenuItemId,
})=> (
  <ul role="list" className="nav-links-list">
    <li key={menuItem.id} className="nav-link-super-wrapper">
      <MenuItemComponent
        menuItem={menuItem}
        currentSubpage={currentSubpage}
        selected={
          lastClickedSubmenuItemId ?
            false
          :
            menuItem.appAction.subpageId === currentSubpage.id && menuItem.isPrimaryForSubpage
        }
      />
    </li>

    {
      map(currentSubmenuItems, (submenuItem)=> (
        <li key={submenuItem.id} className="nav-link-super-wrapper">
          <SubmenuItemComponent
            submenuItem={submenuItem}
            currentSubpage={currentSubpage}
            lastClickedSubmenuItemId={lastClickedSubmenuItemId}
          />
        </li>
      ))
    }
  </ul>
);

const MainNavigationWithToplevelSubmenuLinksUi_ViewerVersion2 = ({
  MenuItemComponent,
  SubmenuItemComponent,
  menuItem,
  currentSubpage,
  currentSubmenuItems,
  lastClickedSubmenuItemId,
  isTranslationsEnabled,
  appliedLanguages,
  currentLanguageIso,
  defaultLanguageIso,
  onLanguageChange
})=> (
  <nav
    key="main-navigation"
    aria-labelledby="globalNavLabel"
    className="navigation-links-container"
  >
    <VisuallyHiddenP id="globalNavLabel">
      Global
    </VisuallyHiddenP>

    {
      isTranslationsEnabled ?
        <Fragment>
          <div className="navigation-links-left">
            <ManNavInner_ViewerVersion2
              menuItem={menuItem}
              currentSubpage={currentSubpage}
              lastClickedSubmenuItemId={lastClickedSubmenuItemId}
              currentSubmenuItems={currentSubmenuItems}
              MenuItemComponent={MenuItemComponent}
              SubmenuItemComponent={SubmenuItemComponent}
            />
          </div>

          <LanguageSelector
            currentIso={currentLanguageIso}
            defaultLanguageIso={defaultLanguageIso}
            appliedLanguages={appliedLanguages}
            onLanguageChange={onLanguageChange}
          />
        </Fragment>
      :
        <ManNavInner_ViewerVersion2
          menuItem={menuItem}
          currentSubpage={currentSubpage}
          lastClickedSubmenuItemId={lastClickedSubmenuItemId}
          currentSubmenuItems={currentSubmenuItems}
          MenuItemComponent={MenuItemComponent}
          SubmenuItemComponent={SubmenuItemComponent}
        />
    }
  </nav>
);

const MainNavigationWithToplevelSubmenuLinksUi = (props)=> (
  <SiteViewerVersionComponentSelector>
    <MainNavigationWithToplevelSubmenuLinksUi_ViewerVersion1 forSiteViewerVersion={1} { ...props } />
    <MainNavigationWithToplevelSubmenuLinksUi_ViewerVersion2 forSiteViewerVersion={2} { ...props } />
  </SiteViewerVersionComponentSelector>
);

export default MainNavigationWithToplevelSubmenuLinksUi;
